<template>
  <div>
    <NavBar />
    <AuthBySessionExpired />
    <div class="container">
      <div class="row">
        <div class="col-md-12 pt-0">
          <v-btn class="btn-return" @click="$router.go(-1)">
            <i class="fas fa-arrow-left mr-2 text-twenty"></i> Voltar
          </v-btn>
        </div>
      </div>
      <Providers />
    </div>
  </div>
</template>

<script>
import NavBar from "../templates/NavBar";

import AuthBySessionExpired from "../templates/Components/AuthBySessionExpired";

import Providers from "../templates/Financial/Provider/Providers";

export default {
  name: "ListProviders",
  components: {
    NavBar,
    AuthBySessionExpired,
    Providers,
  },
};
</script>
